import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { CloudUploadOutlined } from '@material-ui/icons';
import Input from '@material-ui/core/Input';
import { makeStyles, createStyles, Theme } from '@material-ui/core';

import { baseTheme } from '../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      color: theme.palette.primary.dark,
      width: '100%',
      border: `dashed 1px ${theme.palette.primary.light}`,
      borderRadius: '10px',
    },
    activeZone: {
      color: theme.palette.primary.main,
      border: `dashed 1px ${theme.palette.primary.main}`,
    },
    iconWrapper: {
      width: '100%',
      margin: '0 auto',
      textAlign: 'center',
      paddingTop: theme.spacing(1),
    },
    icon: {
      fontSize: '200px',
    },
    instruction: {
      width: '90%',
      margin: '0 auto',
      textAlign: 'center',
      paddingBottom: theme.spacing(1),
    },
    rejection: {
      width: '90%',
      margin: '0 auto',
      textAlign: 'center',
      paddingBottom: theme.spacing(1),
      color: theme.palette.error.main,
    },
  }),
);

export default function FileDropZone(props: any) {
  const { handleDropFiles } = props;
  const styles = useStyles(baseTheme);
  const [rejectionMessage, setRejectionMessage] = useState('');

  const onDrop = useCallback((acceptedFiles, rejectedFiles = []) => {
    if (rejectedFiles[0]) {
      rejectedFiles[0].errors.forEach((error: any) => {
        if (error.message) {
          setRejectionMessage(error.message);
        }
      });
    } else {
      setRejectionMessage('');
    }
    handleDropFiles(acceptedFiles.map((file: File) => Object.assign(file, {
      blobUrl: URL.createObjectURL(file),
    })));
  }, [handleDropFiles]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, accept: ['image/jpeg', 'image/png'] });

  const isActive = () => isDragActive ?
    `${styles.root} ${styles.activeZone}` :
    `${styles.root}`;

  return (
    <div {...getRootProps()} className={isActive()}>
      <Input inputProps={{ ...getInputProps() }} />
      <div className={styles.iconWrapper}><CloudUploadOutlined className={styles.icon} /></div>
      <h3 className={styles.instruction}>
        Click here to Open File Browser, or Drag and Drop File Here
      </h3>
      <h3 className={styles.instruction}>
        JPEG and PNG accepted
      </h3>
      {rejectionMessage &&
      <h3 className={styles.rejection}>
          {rejectionMessage}
      </h3>}
    </div>
  );
}
